"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Reciept: function() {
        return Reciept;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Reciept = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3.52814 22.8817C3.8533 23.0557 4.24784 23.0366 4.5547 22.8321L6.94629 21.2377L8.87531 22.7809C9.24052 23.073 9.75948 23.073 10.1247 22.7809L12 21.2806L13.8753 22.7809C14.2405 23.073 14.7595 23.073 15.1247 22.7809L17.0537 21.2377L19.4453 22.8321C19.7522 23.0366 20.1467 23.0557 20.4719 22.8817C20.797 22.7077 21 22.3688 21 22V4C21 2.34315 19.6569 1 18 1H6C4.34315 1 3 2.34315 3 4V22C3 22.3688 3.20298 22.7077 3.52814 22.8817ZM5 20.1315V4C5 3.44772 5.44772 3 6 3H18C18.5523 3 19 3.44772 19 4V20.1315L17.5547 19.1679C17.1924 18.9264 16.7154 18.9471 16.3753 19.2191L14.5 20.7194L12.6247 19.2191C12.2595 18.927 11.7405 18.927 11.3753 19.2191L9.5 20.7194L7.62469 19.2191C7.28464 18.9471 6.80764 18.9264 6.4453 19.1679L5 20.1315ZM7 15C7 15.5523 7.44772 16 8 16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H8C7.44772 14 7 14.4477 7 15ZM7 11C7 11.5523 7.44772 12 8 12H16C16.5523 12 17 11.5523 17 11C17 10.4477 16.5523 10 16 10H8C7.44772 10 7 10.4477 7 11ZM7 7C7 7.55229 7.44772 8 8 8H11C11.5523 8 12 7.55229 12 7C12 6.44771 11.5523 6 11 6H8C7.44772 6 7 6.44771 7 7Z",
        fill: "currentColor"
    })
}), "Reciept");
const _default = Reciept;
